<template>
	<div class="title-page-wrapper">
		<div class="title-page-wrapper-2">
			<div class="image-block">
				<title-image v-if="!ownerId" key="title-image" class="title-image" />
				<img v-else :key="'title-image-' + ownerId" class="title-image owner-logo" :src="ownerImage" alt="">
			</div>
			
			<div class="login-buttons-block">
				<div>
					<div v-if="t.mainPagePitch" class="pitch">
						{{ t.mainPagePitch }}
					</div>

					<login-block />
				</div>
			</div>
		</div>

		<partner-logos-block v-if="settings.ui.partnerBlockShow" />
	</div>
</template>

<script setup>
import { ref, computed, onMounted, inject } from 'vue';
import partnerLogosBlock from '@/js/components/blocks/partner-logos-block.vue'
import LoginBlock from '@/js/components/blocks/login.vue'
import TitleImage from "@/svg/customer/images/landing-page/title.svg"
import { preloadImages } from '../includes/helpers';
import { useStore } from '@/js/stores/index';

const axios = inject('axios')
const store = useStore()

// Emits
const emit = defineEmits(['loaded'])

// Reactives
const ownerImage = ref('')
const ownerName = ref('')

// Computeds
const t = computed(() => store.translations)
const ownerId = computed(() => store.owner.id)
const settings = computed(() => store.settings)

// Lifecycle
onMounted(async () => {
	if(ownerId.value){
		const response = await axios.get('/api/user-side/getOwner/' + ownerId.value)

		ownerImage.value = '/image/i.' + response.data.owner_image_id + '/w.800:h.800:f.0/image.png'
		ownerName.value = response.data.owner_name
		document.title = response.data.owner_name // Set title

		preloadImages([ ownerImage.value ]).then(() => {
			emit('loaded')
		})
	}else{
		emit('loaded')
	}
})

</script>
